module.exports = __webpack_public_path__ + "static/spellguard_shield-4ac45b3ffa2229fe8d9c3b57541cfb91.jpeg";